export default __webpack_public_path__ + "85fe85850b026b668c10d2c9e0e5e8c6.js";